import { Controller } from "@hotwired/stimulus";

const LINK_PLACEHOLDER = "https://";

export default class extends Controller {
  static targets = ["input"];

  wrap({ params: { before, after } }) {
    const { selectionStart, selectionEnd, value } = this.inputTarget;
    const selected = value.slice(selectionStart, selectionEnd);

    this.replaceSelection(`${before}${selected}${after}`);
    this.select(selectionStart + before.length, selectionStart + before.length + selected.length);
  }

  prefixLines({ params: { prefix } }) {
    const { selectionStart, selectionEnd, value } = this.inputTarget;
    const lineStart = value.lastIndexOf("\n", selectionStart - 1) + 1;
    const nextBreak = value.indexOf("\n", selectionEnd);
    const lineEnd = nextBreak === -1 ? value.length : nextBreak;
    const prefixed = value
      .slice(lineStart, lineEnd)
      .split("\n")
      .map((line) => (line.startsWith(prefix) ? line : `${prefix}${line}`))
      .join("\n");

    this.select(lineStart, lineEnd);
    this.replaceSelection(prefixed);
    this.select(lineStart + prefixed.length, lineStart + prefixed.length);
  }

  link() {
    const { selectionStart, selectionEnd, value } = this.inputTarget;
    const label = value.slice(selectionStart, selectionEnd);
    const urlStart = selectionStart + `[${label}](`.length;

    this.replaceSelection(`[${label}](${LINK_PLACEHOLDER})`);
    this.select(urlStart, urlStart + LINK_PLACEHOLDER.length);
  }

  insert({ params: { text } }) {
    const { selectionStart } = this.inputTarget;

    this.replaceSelection(text);
    this.select(selectionStart + text.length, selectionStart + text.length);
  }

  replaceSelection(text) {
    this.inputTarget.focus();

    if (document.execCommand("insertText", false, text)) return;

    this.inputTarget.setRangeText(text);
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
  }

  select(start, end) {
    this.inputTarget.focus();
    this.inputTarget.setSelectionRange(start, end);
  }
}
